import { Routes } from '@angular/router';
import { CartPage } from '@apps/mtjr/customers/app/cart/cart.page';
import { CheckoutPage } from '@apps/mtjr/customers/app/cart/checkout.page';
import { AddProductReviewCreatePage } from '@apps/mtjr/customers/app/feedback/product-review.page';
import { LandingPage } from '@apps/mtjr/customers/app/landing/landing.page';
import { NotFoundPage } from '@apps/mtjr/customers/app/not-found/not-found.page';
import { OrderDetailsPage } from '@apps/mtjr/customers/app/orders/order-details.page';
import { OrdersPage } from '@apps/mtjr/customers/app/orders/orders.page';
import { ProductDetailsPage } from '@apps/mtjr/customers/app/product_details/product-details.page';
import { PublicCheckoutPage } from '@apps/mtjr/customers/app/public-checkout/public-checkout.page';
import { SettingsPage } from '@apps/mtjr/customers/app/settings/settings.page';
import { SharedCartPage } from '@apps/mtjr/customers/app/shared-cart/shared-cart.page';
import { TabsPage } from '@apps/mtjr/customers/app/tabs/tabs.page';
import { VendorsListPage } from '@apps/mtjr/customers/app/vendors/list/vendors-list.page';
import { WishlistPage } from '@apps/mtjr/customers/app/wishlist/wishlist.page';
import { nativeAuthGuard } from '@libs/core/lib/auth/native-auth.guard';
import { AddressPage } from '@libs/mtjr/shared/address/address.page';
import { CreateAddressPage } from '@libs/mtjr/shared/address/create_address.page';
import { EditAddressPage } from '@libs/mtjr/shared/address/edit_address.page';
import { CancelOrderPage } from '@libs/mtjr/shared/orders/cancel-order.page';
import { ProductReviewsPage } from '@libs/mtjr/shared/products/product_reviews.page';
import { VendorDetailsPage } from '@libs/mtjr/shared/vendors/details/vendor-details.page';
import { WalletPageComponent } from '@libs/mtjr/shared/wallet/wallet.page';

// export const authGuard = Capacitor.isNativePlatform() ? nativeAuthGuard : autoLoginPartialRoutesGuard;
export const authGuard = nativeAuthGuard;

export const routes: Routes = [
  // Standalone public checkout page (no tabs/sidebar, no auth)
  {
    path: 'public-checkout/:orderId',
    component: PublicCheckoutPage,
  },
  {
    path: '',
    component: TabsPage,
    children: [
      {
        path: '',
        redirectTo: 'landing',
        pathMatch: 'full',
      },

      // Public routes (no authentication required)
      // Landing stack
      {
        path: 'landing',
        component: LandingPage,
      },
      {
        path: 'landing/vendors/:vendorId',
        component: VendorDetailsPage,
      },
      {
        path: 'landing/vendors/:vendorId/products/:productId',
        component: ProductDetailsPage,
      },
      {
        path: 'landing/vendors/:vendorId/products/:productId/reviews',
        component: ProductReviewsPage,
      },

      // Vendors stack
      {
        path: 'vendors',
        component: VendorsListPage,
      },
      {
        path: 'vendors/:vendorId',
        component: VendorDetailsPage,
      },
      {
        path: 'vendors/:vendorId/products/:productId',
        component: ProductDetailsPage,
      },
      {
        path: 'vendors/:vendorId/products/:productId/reviews',
        component: ProductReviewsPage,
      },
      {
        path: 'settings',
        component: SettingsPage,
      },
      // Cart routes (checkout requires authentication)
      {
        path: 'cart',
        children: [
          {
            path: '',
            component: CartPage,
          },
          {
            path: 'checkout',
            component: CheckoutPage,
            canActivate: [authGuard],
          },
        ],
      },
      {
        path: 'shared-cart/:id',
        component: SharedCartPage,
      },

      // Protected routes (authentication required)
      {
        path: 'orders',
        canActivate: [authGuard],
        children: [
          {
            path: '',
            component: OrdersPage,
          },
          {
            path: ':orderId',
            children: [
              {
                path: '',
                component: OrderDetailsPage,
              },
              {
                path: 'add-review/:subOrderId/:productId',
                component: AddProductReviewCreatePage,
              },
              {
                path: ':subOrderId/cancel',
                component: CancelOrderPage,
              },
            ],
          },
        ],
      },
      {
        path: 'wishlist',
        component: WishlistPage,
        canActivate: [authGuard],
      },
      {
        path: 'wishlist/vendors/:vendorId/products/:productId',
        component: ProductDetailsPage,
        canActivate: [authGuard],
      },
      {
        path: 'wallet',
        component: WalletPageComponent,
        canActivate: [authGuard],
      },
      {
        path: 'account',
        canActivate: [authGuard],
        children: [
          {
            path: 'addresses',
            children: [
              {
                path: '',
                component: AddressPage,
              },
              {
                path: 'create',
                component: CreateAddressPage,
              },
              {
                path: ':addressId/edit',
                component: EditAddressPage,
              },
            ],
          },
        ],
      },
      // Wildcard route for unmatched paths
      {
        path: '**',
        component: NotFoundPage,
      },
    ],
  },
];
